import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { MediaLibrary } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/media-library")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <MediaLibrary />
    </RouteGuard>
  ),
});
